import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';

const STOCKAI_PREFIX = process.env.REACT_APP_STOCKAI_ONLY === '1' ? '' : '/stockai';

export default function Intro() {
  const { loggedIn, mock, openLogin } = useOutletContext() || {};

  return (
    <div>
      <div className="stockai-kicker">Product Introduction</div>

      <section className="stockai-hero">
        <div className="stockai-hero__panel">
          <h1 className="stockai-hero__headline">AI가 추천하고, 사용자가 통제하는 거래 운영 화면</h1>
          <p className="stockai-hero__lead">
            제우스 StockAI는 추천 종목, 자동매매 설정, 포트폴리오 리스크, 알림 흐름을
            한 제품 안에서 연결해주는 AI 트레이딩 스튜디오입니다.
          </p>
          <div className="stockai-hero__actions">
            {loggedIn || mock ? (
              <Link className="stockai-btn" to={`${STOCKAI_PREFIX}/dashboard`}>대시보드 시작</Link>
            ) : (
              <button type="button" className="stockai-btn" onClick={openLogin}>실 API 로그인</button>
            )}
            <Link className="stockai-btn stockai-btn--ghost" to={`${STOCKAI_PREFIX}/ai`}>AI 추천 보기</Link>
          </div>
        </div>

        <div className="stockai-hero__aside">
          <div className="stockai-card stockai-stat-card">
            <div className="stockai-metric">
              <span className="stockai-metric__eyebrow">서비스 모드</span>
              <strong className="stockai-metric__value">{loggedIn ? 'Live' : mock ? 'Mock' : 'Ready'}</strong>
              <span className="stockai-metric__meta">
                {loggedIn
                  ? '로그인됨 — 실 시세·실 주문 실행 모드'
                  : '로그인 시 실 API로 전환. 미로그인 시 목업 미리보기 가능'}
              </span>
            </div>
          </div>
          <div className="stockai-card">
            <h3 className="stockai-card__title">핵심 흐름</h3>
            <div className="stockai-chip-list">
              <span className="stockai-chip">추천 확인</span>
              <span className="stockai-chip">성향 설정</span>
              <span className="stockai-chip">주문 실행</span>
              <span className="stockai-chip">알림 추적</span>
            </div>
          </div>
        </div>
      </section>

      <section className="stockai-section">
        <div className="stockai-section__header">
          <div>
            <h2 className="stockai-section__title">StockAI가 제공하는 기능</h2>
            <div className="stockai-section__subtitle">개편안의 스튜디오형 UX를 StockAI 업무 흐름에 맞춰 정리했습니다.</div>
          </div>
        </div>

        <div className="stockai-grid stockai-grid--2">
          <div className="stockai-card stockai-feature-card">
            <div className="stockai-badge">01</div>
            <h3 className="stockai-card__title">AI 추천 스테이션</h3>
            <p className="stockai-stat-label">
              추천 종목, 신뢰도, 추천 이유를 요약하고 설정 화면과 바로 연결합니다.
            </p>
          </div>
          <div className="stockai-card stockai-feature-card">
            <div className="stockai-badge">02</div>
            <h3 className="stockai-card__title">상세 운영 설정</h3>
            <p className="stockai-stat-label">
              자동매수/매도, 알림 채널, 구매 성향, 실행 컨트롤을 한 곳에서 조정합니다.
            </p>
          </div>
          <div className="stockai-card stockai-feature-card">
            <div className="stockai-badge">03</div>
            <h3 className="stockai-card__title">실행 콘솔</h3>
            <p className="stockai-stat-label">
              추천을 본 뒤 바로 주문 티켓으로 이동해 종목코드와 수량, 가격을 검토합니다.
            </p>
          </div>
          <div className="stockai-card stockai-feature-card">
            <div className="stockai-badge">04</div>
            <h3 className="stockai-card__title">모니터링 루프</h3>
            <p className="stockai-stat-label">
              포트폴리오와 알림 상태를 확인하며 실행 결과를 다시 설정에 반영합니다.
            </p>
          </div>
        </div>
      </section>

      <section className="stockai-section">
        <div className="stockai-panel-grid">
          <div className="stockai-card">
            <h3 className="stockai-card__title">사용 흐름</h3>
            <ul className="stockai-mini-list">
              <li>
                <strong>1. 소개/온보딩</strong>
                <div className="stockai-stat-label">서비스 구조와 핵심 기능을 파악합니다.</div>
              </li>
              <li>
                <strong>2. 추천/설정 연결</strong>
                <div className="stockai-stat-label">추천 종목을 보고 구매 성향과 AI 설정을 조정합니다.</div>
              </li>
              <li>
                <strong>3. 실행/알림</strong>
                <div className="stockai-stat-label">주문을 실행하고 알림 흐름으로 상태를 추적합니다.</div>
              </li>
            </ul>
          </div>
          <div className="stockai-card">
            <h3 className="stockai-card__title">바로 이동</h3>
            <div className="stockai-cta-stack">
              <Link className="stockai-btn" to={`${STOCKAI_PREFIX}/settings`}>상세 설정 열기</Link>
              <Link className="stockai-btn stockai-btn--ghost" to={`${STOCKAI_PREFIX}/ai`}>추천 화면 보기</Link>
              <Link className="stockai-btn stockai-btn--ghost" to={`${STOCKAI_PREFIX}/trade`}>거래 콘솔 이동</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
